// Home "For you" feed helpers (GET /products/for-you, API_CONTRACT §2 G65).
import { getForYouFeed } from './api';
import { getRecentlyViewedCategories, getRecentlyViewedIds } from './recentlyViewed';

/** The feed for this shopper: sends the device view history as seen/cats. */
export const loadForYou = ({ limit, cursor } = {}, opts) => getForYouFeed({
  limit,
  cursor,
  seen: getRecentlyViewedIds(),
  cats: getRecentlyViewedCategories(),
}, opts);

// A category name may be {en, ar} or plain text.
const nameOf = (name) => {
  if (!name) return null;
  if (typeof name === 'string') return { en: name, ar: name };
  const en = name.en || name.ar;
  return en ? { en, ar: name.ar || en } : null;
};

/** What a `because_*` reason points at: {en, ar} for the category or brand. */
const subjectOf = (detail) => {
  if (!detail) return null;
  if (typeof detail.brand === 'string' && detail.brand.trim()) {
    const b = detail.brand.trim();
    return { en: b, ar: b };
  }
  return nameOf(detail.category?.name);
};

const withSubject = (subject, en, ar, fallback) => (subject
  ? { en: en.replace('{x}', subject.en), ar: ar.replace('{x}', subject.ar) }
  : fallback);

/**
 * Chip text ({en, ar}) for a feed item's `reason`, or null when no chip is
 * shown (`new` — the card has its own New badge — and unknown codes).
 */
export const forYouReasonLabel = (item) => {
  const subject = subjectOf(item?.reason_detail);
  switch (item?.reason) {
    case 'because_viewed':
      return withSubject(subject, 'Because you viewed {x}', 'لأنك شاهدت {x}',
        { en: 'Based on what you viewed', ar: 'بناءً على ما شاهدته' });
    case 'because_wishlist':
      return withSubject(subject, 'Because you saved {x}', 'لأنك حفظت {x}',
        { en: 'Like pieces you saved', ar: 'يشبه ما حفظته' });
    case 'because_purchased':
      return withSubject(subject, 'Because you bought {x}', 'لأنك اشتريت {x}',
        { en: 'Based on your orders', ar: 'بناءً على طلباتك' });
    case 'in_your_size':
      return { en: 'In your size', ar: 'متوفر بمقاسك' };
    case 'your_colours':
      return { en: 'In your colours', ar: 'بألوانك' };
    case 'trending':
      return { en: 'Trending', ar: 'رائج الآن' };
    default:
      return null;
  }
};
